import { render, staticRenderFns } from "./LastQuestionWarning.vue?vue&type=template&id=1c464b27&"
import script from "./LastQuestionWarning.vue?vue&type=script&lang=ts&"
export * from "./LastQuestionWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports